import { useLocalFilterState } from '../hooks/useFilterState'

export const WithFilterStateLocal = (props: { children: Function }) => {
  const { filterState, updateFilterState } = useLocalFilterState()
  return props.children({ filterState, updateFilterState })
}
